import type { PartnerRuleCriterion, PartnerRuleCriterionDefinition } from '@shipium-corp/shipium-ts-types';
import type { RuleActionType } from '~/store/services/RuleSetServiceV2/types';
import type { RulePageForm } from '~/pages/PartnerConfigPages/Rulesets/types';
import { CRITERIA_SELECTION_TO_RULE_ACTION_TYPE } from '~/pages/PartnerConfigPages/Rulesets/types';
import {
  buildOriginCriteria,
  buildShipFromCountryCriteria,
  buildShipFromRegionCriteria,
  buildShipFromPostalCriteria,
  buildDestinationCountryCriteria,
  buildDestinationRegionCriteria,
  buildDestinationPostalCriteria,
  buildShipmentTagCriteria,
  buildPackageWeightCriteria,
  buildPoBoxCriteria,
  buildExactDateDeliveryCriteria,
  buildShipOptionCriteria,
  buildHazardousCriteria,
  isCriteriaDisabled,
} from '~/pages/PartnerConfigPages/Rulesets/utils';
import { ruleCriteriaToFilter, type RuleImpactFilterResult } from './ruleCriteriaToTypesenseFilter';

function definitionToCriterion(def: PartnerRuleCriterionDefinition): PartnerRuleCriterion {
  return {
    ruleProperty: { rulePropertyEnum: def.rulePropertyEnum },
    ruleComparator: { ruleComparatorEnum: def.ruleComparatorEnum },
    compareValue: def.compareValue,
    scalarUnit: def.scalarUnitEnum ? { scalarUnitEnum: def.scalarUnitEnum } : undefined,
  };
}

export function ruleFormToFilter(values: Partial<RulePageForm>): RuleImpactFilterResult {
  const definitions: PartnerRuleCriterionDefinition[] = [
    buildOriginCriteria(values),
    buildShipFromCountryCriteria(values),
    buildShipFromRegionCriteria(values),
    buildShipFromPostalCriteria(values),
    buildDestinationCountryCriteria(values),
    buildDestinationRegionCriteria(values),
    buildDestinationPostalCriteria(values),
    buildShipmentTagCriteria(values),
    buildPackageWeightCriteria(values),
    buildPoBoxCriteria(values),
    buildExactDateDeliveryCriteria(values),
    buildShipOptionCriteria(values),
    buildHazardousCriteria(values),
  ].filter((c): c is PartnerRuleCriterionDefinition => c !== null);

  const criteria = definitions.map(definitionToCriterion);
  const tenants = isCriteriaDisabled(values.tenantCriteria) ? undefined : values.tenants;
  return ruleCriteriaToFilter(criteria, tenants, values.eligibleCarrierServiceMethods);
}

export function formListType(
  carrierSelectionCriteria: RulePageForm['carrierSelectionCriteria'] | undefined,
): RuleActionType {
  return carrierSelectionCriteria ? CRITERIA_SELECTION_TO_RULE_ACTION_TYPE[carrierSelectionCriteria] : 'block';
}
